import { render } from "./OpportunitiesTable.vue?vue&type=template&id=7b00dcbb&scoped=true"
import script from "./OpportunitiesTable.vue?vue&type=script&lang=js"
export * from "./OpportunitiesTable.vue?vue&type=script&lang=js"

import "./OpportunitiesTable.vue?vue&type=style&index=0&id=7b00dcbb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b00dcbb"

export default script